export const NOTIFICATION_ID = 'successful-additon-to-cart';